var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 18.9577H7.50033C2.97533 18.9577 1.04199 17.0243 1.04199 12.4993V7.49935C1.04199 2.97435 2.97533 1.04102 7.50033 1.04102H12.5003C17.0253 1.04102 18.9587 2.97435 18.9587 7.49935V12.4993C18.9587 17.0243 17.0253 18.9577 12.5003 18.9577ZM7.50033 2.29102C3.65866 2.29102 2.29199 3.65768 2.29199 7.49935V12.4993C2.29199 16.341 3.65866 17.7077 7.50033 17.7077H12.5003C16.342 17.7077 17.7087 16.341 17.7087 12.4993V7.49935C17.7087 3.65768 16.342 2.29102 12.5003 2.29102H7.50033Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81621 12.9827C8.64954 12.9827 8.49121 12.916 8.37454 12.7993L6.01621 10.441C5.77454 10.1993 5.77454 9.79935 6.01621 9.55768C6.25788 9.31602 6.65788 9.31602 6.89954 9.55768L8.81621 11.4743L13.0995 7.19102C13.3412 6.94935 13.7412 6.94935 13.9829 7.19102C14.2245 7.43268 14.2245 7.83268 13.9829 8.07435L9.25788 12.7993C9.14121 12.916 8.98288 12.9827 8.81621 12.9827Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSquare);
export default __webpack_public_path__ + "static/media/tick-square.d48b45ab932709883492f4ad8a2791b4.svg";
export { ForwardRef as ReactComponent };